<template>
    <div
        v-gesture:start="start"
        v-gesture:pressMove="pressMove"
        v-gesture:end="end"
        v-gesture:mouseLeave="end"
        class="refresh-block"
        :style="{transform:`translate3d(0,${getDistanceY}px,0)`}">
        <div class="pull-refresh">
            <i :class="text"/>
        </div>
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "Refresh",
        props: {
            scrollTops:{},
        },
        data() {
            return {
                //下拉刷新
                distanceY: 0,
                clientY: 0,
                scrollTop: this.scrollTops,
                startY: 0,
                currentY: 0,
                overDistance: 0,
                text: 'el-icon-refresh',
                point: 150,
            }
        },
        computed: {
            getDistanceY() {
                return this.distanceY * 0.6
            }
        },
        created() {

        },
        mounted() {

        },
        watch: {
            scrollTops(){
                this.scrollTop= this.scrollTops
            },
        },
        methods: {
            //下拉刷新
            start(evt) {
                this.startY = evt.clientY || evt.touches[0].clientY
            },
            pressMove(evt) {
                evt.stopPropagation()
                this.currentY = evt.clientY || evt.touches[0].clientY
                //  滚动到顶部，并且是下拉手势
                if (this.scrollTop === 0 && this.currentY - this.startY > 0 && evt.cancelable) {
                    evt.preventDefault()
                    //超出的距离
                    this.distanceY += Math.round(evt.deltaY)
                    if (this.distanceY > this.point) {
                        this.text = 'el-icon-loading'
                    } else {
                        this.text = 'el-icon-refresh'
                    }
                }
            },
            end(evt) {
                if (this.distanceY > 0) {
                    // 当下拉到达临界点開始重刷
                    if (this.distanceY >= this.point) {
                        this.text = 'el-icon-loading'
                        //更新頁面
                        this.$emit('result');
                        this.animation(
                            this.distanceY,
                            this.point - this.distanceY,
                            val => {
                                this.distanceY = Math.round(val)
                            },
                            () => {
                                setTimeout(() => {
                                    //重刷完成後
                                    this.text = ''
                                    this.animation(this.distanceY, 0 - this.distanceY, val => {
                                        this.distanceY = Math.round(val)
                                    })
                                }, 500)
                            }
                        )
                    } else {
                        this.animation(this.distanceY, 0 - this.distanceY, val => {
                            this.distanceY = Math.round(val)
                        })
                    }
                }
            },
            animation(startValue, diffValue, moveIng, success) {
                let d = Math.ceil(500 / 16.7)
                let timer = null
                let t = 0
                move()
                function move() {
                    if (t > d || d === 0) {
                        cancelAnimationFrame(timer)
                        t = 0
                        success && success()
                    } else {
                        t++
                        let val = easeOutStrong(t, startValue, diffValue, d)
                        moveIng(val)
                        timer = requestAnimationFrame(move)
                    }
                }
                /*
                  t, 当前执行动画第几次
                  b, 起始值
                  c, 目标值-起始值
                  d  动画执行总次数
                  返回值： 当前次 元素应在在的一个位置
                */
                function easeOutStrong(t, b, c, d) {
                    return -c * ((t = t / d - 1) * t * t * t - 1) + b
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    .refresh-block{
        //桌面端不下拉重載
        @media(min-width: 1024px){
            transform: none !important;
        }
    }
    .pull-refresh {
        height: 50px;
        margin-top: -50px;
        text-align: center;
        @media(min-width: 1024px){
            display: none;
        }
        i{
            margin-top: 10px;
            font-size: 28px;
            color: var(--color-yellow4);
        }
    }
</style>